<template>
  <ul class="navbar-nav navbar-right">
    <li class="dropdown navbar-user">
      <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
        <img src="/beta/static/img/admin/avatars/default-user-64.png" class="img-avatar" alt="admin">
        <span class="d-none d-md-inline">Admin</span> <b class="caret"></b>
      </a>
      <div class="dropdown-menu dropdown-menu-right">
        <a href="javascript:;" class="dropdown-item">Setting</a>
        <div class="dropdown-divider"></div>
        <a href="/beta/admin/logout" class="dropdown-item">Log Out</a>
      </div>
    </li>
  </ul>
</template>
<script>
import Vuex from 'vuex'
export default {
  name: 'header-dropdown',
  methods: {
    ...Vuex.mapActions(['logout'])
  }
}
</script>
<style>
.img-avatar {
  background: #E4E5E6;
}
</style>



// WEBPACK FOOTER //
// src/admin/components/Header/HeaderDropdown.vue